(function () {
  var pushed = {};

  function cookieValue(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function currentVariant() {
    var fromCookie = cookieValue('eligens_ab');
    if (fromCookie === 'new' || fromCookie === 'old') return fromCookie;
    if (window.__eligensAb === 'new' || window.__eligensAb === 'old') return window.__eligensAb;
    if (/new\.eligens/i.test(location.hostname)) return 'new';
    return '';
  }

  function persistCartVariant(variant) {
    if (!variant || persistCartVariant.sent === variant) return;
    persistCartVariant.sent = variant;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        if (attrs.eligens_ab === variant) return;
        var next = {};
        Object.keys(attrs).forEach(function (key) { next[key] = attrs[key]; });
        next.eligens_ab = variant;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: next })
        });
      })
      .catch(function () {});
  }

  function track(name, params) {
    if (!name) return;
    var variant = currentVariant();
    var payload = params ? Object.assign({ event: name }, params) : { event: name };
    if (variant && !payload.eligens_ab) payload.eligens_ab = variant;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (err) {}
  }

  function trackOnce(key, name, params) {
    if (pushed[key]) return;
    pushed[key] = true;
    track(name, params);
  }

  function hrefOf(node) {
    if (!node) return '';
    var href = node.getAttribute && (node.getAttribute('href') || node.getAttribute('action'));
    return String(href || '').toLowerCase();
  }

  function closestLink(target) {
    if (!target || !target.closest) return null;
    return target.closest('a, button, [data-ga-event]');
  }

  document.addEventListener('click', function (event) {
    var node = closestLink(event.target);
    if (!node) return;
    var explicit = node.getAttribute('data-ga-event');
    if (explicit) {
      track(explicit);
      return;
    }

    var href = hrefOf(node);
    var text = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

    if (href.indexOf('tel:') === 0) {
      track('leads-phone');
      return;
    }
    if (href.indexOf('my.eligens') !== -1 || node.classList.contains('site-header__account') || /account|личн|cuenta|conta/.test(text)) {
      track('account-button');
      track('click_on_lk_button_main');
      return;
    }
    if (href.indexOf('/pages/instructions') !== -1 || href.indexOf('/instructions') !== -1) {
      track('how_to_take_a_dna_click');
      return;
    }
    if (href.indexOf('/pages/reviews') !== -1 || href.indexOf('/reviews') !== -1) {
      track('all_reviews_click');
      return;
    }
    if (href.indexOf('/demo') !== -1 || href.indexOf('#reader') !== -1) {
      track('get-demo');
      return;
    }
    if (href.indexOf('/collections/') !== -1 || /all dna|все тест|todas las pruebas|todos os testes/.test(text)) {
      track('all_dna_tests_click');
      return;
    }
    if (node.matches('.btn.lime, .btn.gold, .btn.mag, .button--accent, .button--lime, .product-form__submit')) {
      track('button_offer');
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.tagName || form.tagName !== 'FORM') return;
    if (form.querySelector('[name="add"]') || form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
      track('add-product');
      track('button_offer');
      return;
    }
    if (form.querySelector('[name="checkout"]')) {
      track('begin-checkout');
      track('begin_payment');
      track('checkout_page');
    }
  }, true);

  window.addEventListener('scroll', function onScroll() {
    var doc = document.documentElement;
    var scrollable = (doc.scrollHeight - doc.clientHeight) || 1;
    if ((window.scrollY || doc.scrollTop) / scrollable >= 0.5) {
      window.removeEventListener('scroll', onScroll);
      trackOnce('scroll50', 'scroll_50_and_more');
    }
  }, { passive: true });

  var variant = currentVariant();
  if (variant) {
    persistCartVariant(variant);
    trackOnce('ab', 'eligens_ab_assigned', { eligens_ab: variant });
    if (window.gtag) {
      window.gtag('set', 'user_properties', { eligens_ab: variant });
      window.gtag('event', 'eligens_ab_assigned', {
        eligens_ab: variant,
        send_to: 'G-44C0SQ6JBZ'
      });
    }
  }
})();
